module.exports = __webpack_public_path__ + "img/girl.da857703.png";